import { memo, useCallback } from 'react';

import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Title from '@wconcept/wconcept-ui-renewal/components/atoms/Title';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';

import Tag from '@wconcept/wconcept-ui-renewal/components/atoms/Tag';
import * as S from './style';

interface IProps {
  /** title */
  title?: string | React.ReactNode;
  /** title2 */
  title2?: string | React.ReactNode;
  /** titleColor */
  titleColor?: string;
  /** subTitle */
  subTitle?: string;
  /** subTitleColor */
  subTitleColor?: string;
  /** buttonText */
  buttonText?: string;
  /** moreButton */
  moreButton?: boolean;
  /** isAd */
  isAd?: boolean;
  /** onClick */
  onClick?: () => void;
}

const ContTitle = ({
  title,
  title2,
  subTitle,
  moreButton,
  titleColor = '#000',
  subTitleColor = '#777',
  buttonText = '더보기',
  isAd = false,
  onClick,
}: IProps) => {
  // ITEM RENDERER : getTitleRender
  const getTitleRender = useCallback(
    () => (
      <>
        <Title level={3}>
          <div className="main-title-wrapper">
            <Text color={titleColor} className="main-title">
              {title}
            </Text>
            {title2 && (
              <Text color={titleColor} className="main-title2">
                {title2}
              </Text>
            )}
          </div>
          {subTitle && (
            <Text size={14} color={subTitleColor} className="sub-title" block>
              {subTitle}
            </Text>
          )}
        </Title>
        {moreButton ? <span className="btn-more">{buttonText}</span> : null}
        {isAd && <Tag className="tag-ad">광고</Tag>}
      </>
    ),
    [
      buttonText,
      isAd,
      moreButton,
      title,
      title2,
      titleColor,
      subTitle,
      subTitleColor,
    ]
  );

  const renderWrapper = useCallback(() => {
    if (moreButton) {
      return (
        <Button onClick={onClick} className="title-enhanced">
          {getTitleRender()}
        </Button>
      );
    }

    if (isAd) {
      return <div className="title-enhanced">{getTitleRender()}</div>;
    }

    return <>{getTitleRender()}</>;
  }, [moreButton, isAd, onClick, getTitleRender]);

  return <S.ContTitle className="section-title">{renderWrapper()}</S.ContTitle>;
};

export default memo(ContTitle);
